const page_500 = {
	description: "Sorry, something went wrong on our side. Please try again later.",
	home_button: "Go to the homepage",
	return_button: "Try again",
	title: "500 Error",
};

export default page_500;
